import httpService from '../../service/httpService'
import store from '../../store'

export default {
  // 注册
  async register(obj) {
    return httpService.post('/register', obj)
  },
  //获取用户信息
  async userInfo() {
    return httpService.get('/info')
  },
  //获取用户信息
  async user_grade(){
    return httpService.get('/user-grade')
  },
  //签到
  async sign() {
    return httpService.get('/user-sign')
  },
  //充值记录
  async rechargeCard(obj) {
    return httpService.get('/rechargeCard',obj)
  },
  //充值
  async post_rechargeCard(obj) {
    return httpService.post('/rechargeCard',obj)
  },
  //获取优惠卷
  async coupon(obj) {
    return httpService.get('/coupon',obj)
  },
  //核销洗车券
  async writeoff(obj) {
    return httpService.post('/writeoff-coupon',obj)
  },
  //会员邀请记录
  async user_recommend() {
    return httpService.get('/user-recommend')
  },
  //获取加油订单列表
  async oil_order_list(obj) {
    return httpService.get('/get-oil-order-list',obj)
  },
  //获取加油订单详情
  async get_oil_order(id) {
    return httpService.get('/get-oil-order/'+id)
  },
  //获取发票授权页url
  async get_authurl(obj) {
    return httpService.get('/invoice/getauthurl',obj)
  },
  //积分列表
  async integral(obj){
    return httpService.get('/integral',obj);
  },
  //累计佣金/已提现佣金/待提现
  async commission_info(){
    return httpService.get('/commission-info');
  },
  //佣金提现
  async commission_cash(obj){
    return httpService.post('/commission-cash',obj);
  },
  //佣金记录列表
  async commission_ist(obj){
    return httpService.get('/commission-list',obj);
  },
  //进入提现界面放回账户信息
  async cash_account(){
    return httpService.get('/cash-account');
  },
  //提现记录列表
  async cash_list(){
    return httpService.get('/cash-list');
  },
  // 获取签名
  async getSignature() {
    let res = await httpService.get('/front/get-wechat-config')
    store.commit('system/updateWxSignature', {
      app_id: res.data.config.app_id,
      jsapi_ticket: res.data.ticket.ticket
    })
    return res
  }
}



// WEBPACK FOOTER //
// ./src/api/auth/index.js